<div class="flex flex-column justify-content-center align-items-center w-full md:px-7 pb-3">
    <h2 class="text-center">This deal is old...</h2>
    <span class="text text-center">
        Looks like this deal expired or no longer meets our price threshold. Head back to the dashboard to find more deals.
    </span>

    <div class="w-full grid mt-4">
        <div class="col-12 py-2">
            <p-button
                label="Go to Dashboard"
                styleClass="learn-btn w-full"
                severity="info"
                (click)="goToDashboard()"
            ></p-button>
        </div>
    </div>
</div>
